import {Form} from '../modules/Form';

/*
* Модуль работает с формами, загружаемыми в попап
* В зависимости от типа формы, существуют различные варианты при успешном ответе и ошибке
* Например, при успешной регистрациии мы перегружаем страницу
* А при успешной отправке письма в поддержку - просто выводим сообщение бо успешной отправке
* Тип формы определеятся в атрибуте data-param
* */

const xhrForm = function(wrapper){
    const param = function(){
        var attr = wrapper.getAttribute('data-param');
        return attr ? JSON.parse(attr) : {};
    }();

    const onsuccess = function(data){
        if(param.type === 'reload') location.replace(location.protocol + '//' + location.host + location.pathname);
        else {
            formObj.resetCaptcha();
            uPopup.closeAll();
            uPopup({
                content:data.message
            });
        }
    };

    const onerror = function(data){
        formObj.resetCaptcha();
        uPopup({
            content:data.message
        });
    };

    const formObj =  new Form({
        wrapper: wrapper,
        onsuccess: onsuccess,
        onerror: onerror
    });

    const destroy = function (){
        formObj.destroy();
    };

    const returnObj = {
        destroy: destroy
    };

    return returnObj;

};

export {xhrForm};



